import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './TransactionsDateColumnApprovedTooltip.scss';
import { FormattedDate } from '../../../components/table/FormattedDate';

export const TransactionsDateColumnApprovedTooltip: FC<{ approvedBy: string; approvedAt: Date }> = ({
  approvedAt,
  approvedBy,
}) => {
  const { t } = useTranslation();

  return (
    <div className="TransactionsDateColumnApprovedTooltip">
      <div className="title">{t('Approved by')}</div>

      <div>{approvedBy}</div>

      <FormattedDate date={approvedAt} />
    </div>
  );
};
